import { useTransition, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import './ModalSchedlings.css'
import './../../componentsCss/ListCard.css'
import Loading from '../../Loading'
import { cpf } from "../../../utils/formats";
import api from "../../../api";
import moment from "moment";
import CloseButton from './../../../assets/img/cross.svg'
function ModalSchedulings({ professional, onHide, show, setShow }) {
    const [loading, setLoading] = useState(false);
    const [schedulings, setSchedulings] = useState([])

    const getSchedulings = async (professional_id) => {
        setLoading(true)
        await api.post("/api/achemed/attendances", {
            professional_id: professional_id
        }).then((response) => {
            setSchedulings(response.data)
        }).finally(() => {
            setLoading(false)
        })
    }
    
    useEffect(() => {
        if (professional != null) {
            getSchedulings(professional.id)
        } else {
            setSchedulings([])
        }
    }, [professional]);

    return (
        <Modal contentClassName="modalpaymentcontent" className="modalpayment" show={show} onHide={onHide} >
            <Modal.Body className="modalBody">
                <div style={{ justifyContent: 'space-between' }} className="row mb-3 pt-2">
                    <h1 style={{ fontSize: 20, width: '50%' }} className="title col-6">Agendamentos: {professional?.name}</h1>
                    <div className="col-3 d-flex justify-content-end" >
                        <img style={{ cursor: 'pointer' }} width={20} onClick={() => {
                            setShow(false)
                        }} alt="close" src={CloseButton} />
                    </div>
                </div>

                <div className="list-schedulings-modal" style={{ padding: '0px 2px', minHeight: 'calc(90vh - 180px)', maxHeight: 'calc(90vh - 180px)', overflowY: 'auto' }}>


                    {loading ? <Loading color="white" /> : <> {
                        schedulings.length > 0 ?
                            schedulings.map((elem, index) => {
                                return (
                                    <div key={index} className='col-11' style={{ padding: '0px 10px', cursor: 'auto', margin: '0 auto' }}>
                                        <div className='card-list row' style={{ position: 'relative', alignItems: 'center', background: '#f2f2f2', padding: 8, opacity: 1, cursor: "auto" }} >

                                            <div className='d-flex col-11 col-sm-3 flex-column'>
                                                <span style={{ color: 'black' }} className='card-list-title card-list-title-column'>nome/cpf</span>
                                                <span style={{ color: 'black' }} className='card-list-name-payment card-list-name-big-info'>{elem.customer_name}</span>
                                            </div>
                                            <div className='d-flex col-11 col-sm-3 flex-column'>
                                                <span style={{ color: 'black' }} className='card-list-title card-list-title-column'>cpf</span>
                                                <span style={{ color: 'black' }} className='card-list-name-payment card-list-name-big-info'>{cpf(elem.customer_cpf)}</span>
                                            </div>
                                            <div className='d-flex col-11 col-sm-3 flex-column'>
                                                <span style={{ color: 'black' }} className='card-list-title card-list-title-column'>telefone</span>
                                                <span style={{ color: 'black' }} className='card-list-name-payment card-list-name-big-info'>{elem.customer_mobile}</span>
                                            </div>
                                            <div className='d-flex col-11 col-sm-3 flex-column align-items-center'>
                                                <span style={{ color: 'black' }} className='card-list-title card-list-title-column'>agendamento</span>
                                                <span style={{ color: 'black' }} className='card-list-name-payment card-list-name-big-info'>{moment(elem.date_scheduling).format('DD/MM/YYYY') + " " + elem.time_starting_booked}</span>
                                                <div className='specialty-card'>
                                                    {elem.status == 0 ? "em espera" : "em atendimento"}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }) : <><div><h6 style={{ textAlign: 'center', marginTop: '26px', color: 'white' }}>Sem Agendamentos</h6></div></>
                    }</>}

                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalSchedulings;